import { useTranslation } from 'react-i18next';
import { S } from '../regureStyles';
import { docTypeLabel, humanizeFieldKey } from '../../utils/docTypeLabels';

const LinkToClaim = ({ selected, linkClaimId, setLinkClaimId, setSelected, handleLink, linking }) => {
  const { t, i18n } = useTranslation();
  const lang = (i18n?.language || 'en').split('-')[0];
  if (!selected) return <></>;

  const classifiedKey = selected.documentType || selected.classification?.documentType;

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 14, padding: 32, width: 480, boxShadow: '0 25px 60px rgba(0,0,0,0.2)' }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: S.textPrimary, marginBottom: 6 }}>{t('screens.unmatchedDocs.linkModal.title')}</div>
        <div style={{ fontSize: 13, color: S.textMuted, marginBottom: 20 }}>
          <strong>{selected.filename || selected.originalName}</strong> — {t('screens.unmatchedDocs.linkModal.classifiedAs')} <em>{docTypeLabel(classifiedKey, lang)}</em>
        </div>

        {/* Extracted fields preview */}
        {Object.keys(selected.extractedFields || {}).length > 0 && (
          <div style={{ background: S.bgCard, border: `1px solid ${S.borderLight}`, borderRadius: 8, padding: '12px 14px', marginBottom: 18 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: S.textMuted, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 8 }}>{t('screens.unmatchedDocs.linkModal.extractedFields')}</div>
            {Object.entries(selected.extractedFields).map(([k, v]) => (
              <div key={k} style={{ display: 'flex', gap: 8, marginBottom: 4 }}>
                <span style={{ fontSize: 12, color: S.textMuted, minWidth: 100 }}>{humanizeFieldKey(k, lang)}:</span>
                <span style={{ fontSize: 12, fontWeight: 500, color: S.textPrimary, fontFamily: 'monospace' }}>{String(v)}</span>
              </div>
            ))}
          </div>
        )}

        <label style={{ fontSize: 13, fontWeight: 500, color: S.textSecondary, display: 'block', marginBottom: 6 }}>{t('screens.unmatchedDocs.linkModal.claimNumberLabel')}</label>
        <input
          value={linkClaimId}
          onChange={e => setLinkClaimId(e.target.value)}
          placeholder={t('screens.unmatchedDocs.linkModal.claimNumberPh')}
          style={{
            width: '100%',
            padding: '10px 12px',
            border: `1px solid ${S.borderLight}`,
            borderRadius: 8,
            fontSize: 14,
            outline: 'none',
            boxSizing: 'border-box',
            marginBottom: 20,
          }}
        />

        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
          <button
            onClick={() => {
              setSelected(null);
              setLinkClaimId('');
            }}
            style={{
              padding: '10px 20px',
              border: `1px solid ${S.borderLight}`,
              borderRadius: 8,
              background: S.bgCard,
              fontSize: 13,
              cursor: 'pointer',
              color: S.textSecondary,
            }}
          >
            {t('screens.unmatchedDocs.linkModal.cancel')}
          </button>
          <button
            onClick={() => handleLink(selected._id)}
            disabled={!linkClaimId.trim() || linking}
            style={{
              padding: '10px 20px',
              background: !linkClaimId.trim() ? '#94a3b8' : `linear-gradient(135deg, ${S.burgundy}, #722f37)`,
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              fontSize: 13,
              fontWeight: 600,
              cursor: !linkClaimId.trim() ? 'not-allowed' : 'pointer',
            }}
          >
            {linking ? t('screens.unmatchedDocs.linkModal.linking') : t('screens.unmatchedDocs.linkModal.link')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LinkToClaim;
